import type { Profile } from '../types/Profile'

export { isProfileIncomplete, isTelefoonValid }

// gelijk aan de validatie van het accountbeheer
const TELEFOON_PATTERN = /^\+?[0-9 ()-]+$/

const isProfileIncomplete = (profile?: Profile) =>
  !!profile && (!profile.telefoon.trim() || !profile.rol.trim())

const isTelefoonValid = (telefoon: string) =>
  !telefoon || TELEFOON_PATTERN.test(telefoon)
